import type customerListId from "./id";

const customerListEn: typeof customerListId = {
	customer_list: {
		title: "Customer List",
		table: {
			title: "Customer Data",
			columns: {
				store: "Store",
				name: "Name",
				email: "Email",
				phone_number: "Phone Number",
				id_card: "ID Card",
				points: "Points",
				status: "Status",
			},
		},
		forms: {
			import: {
				button: "Import Customer",
				title: "Import Customer",
				description: "Impor customer data",
			},
			edit: {
				title: "Change Customer",
				description: "Change Customer Data",
				info: "Customer Information",
				fields: {
					store: {
						label: "Store",
						placeholder: "Choose Store",
						not_found: "Cannot Found any Store",
					},
					phone_number: {
						label: "Phone Number",
						placeholder: "Enter phone number",
					},
					id_card: {
						label: "ID Card",
						placeholder: "Enter ID card",
					},
					points: {
						label: "Points",
						placeholder: "Enter points",
					},
					status: {
						placeholder: "Choose Status",
					},
				},
			},
			delete: {
				title: "Delete Customer",
				description: "Are you sure want to delete {name}?",
			},
		},
		actions: {
			save: "Save",
			saving: "Saving...",
			cancel: "Cancel",
			save_changes: "Save Change",
			saving_changes: "Saving changes...",
			delete: "Delete",
			deleting: "Deleting...",
			upload: "Upload",
			uploading: "Uploading...",
		},
		status: {
			active: "Active",
			inactive: "Inactive",
		},
		empty_state: {
			title: "No Customer Data",
			description: "Please add new customer data.",
		},
	},
};

export default customerListEn;
